import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { FaExpandArrowsAlt, FaCrosshairs } from "react-icons/fa";
import { useNavigate } from "react-router";
import axios from "axios";
import { ServerAddress } from "../../constants/ServerAddress";
import { setUserDepartment } from "../../store/authentication/Authentication";
import useWindowDimensions from "./ScreenSize";
import BirthdayModal from "./timeLineSection/birthDay/BirthdayModal";
import { Button } from "reactstrap";
import Modal from "react-bootstrap/Modal";
import DefaultDashboard from "./DefaultDashboard";
import ClientDashboard from "./dashboardTypes/ClientDashboard";
import DashboardTimelineSection from "./DashboardTimelineSection";
import NSearchInput from "../../components/formComponent/nsearchInput/NSearchInput";
import VmsDashboard from "./dashboardTypes/VmsDashboard";
import TripDashboard from "./dashboardTypes/TripDashboard";
import BillingDashboard from "./dashboardTypes/BillingDashboard";
import "./Dashboard.css";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import {
  authenticationSlice,
  setis_first_login,
} from "../../store/authentication/Authentication";
import toTitleCase from "../../lib/titleCase/TitleCase";
import { HiCheckBadge } from "react-icons/hi2";
import NewDasboard from "./NewDasboard";
import CorrectionRequestDashboard from "./dashboardTypes/CorrectionRequestDashboard";
import { RxCross2 } from "react-icons/rx";
import RightSidebar from "./RightSidebar";

const Dashboard = () => {
  const navigate = useNavigate();

  // Redux State
  const department = useSelector((state) => state.authentication.userdetails);
  const [dep_id, setdep_id] = useState("");
  const accessToken = useSelector((state) => state.authentication.access_token);
  const userdetails = useSelector((state) => state.authentication.userdetails);
  console.log("userdetails--", userdetails);
  const [is_first_login, setis_first_login] = useState(false);

  const dispatch = useDispatch();

  const today = new Date();

  const year = today.getFullYear();

  const month = today.getMonth() + 1;
  const day = today.getDate();

  const hours = today.getHours();
  const minutes = today.getMinutes();
  const seconds = today.getSeconds();

  const formattedDate = `${year}-${month < 10 ? "0" + month : month}-${day < 10 ? "0" + day : day
    }`;


  const formattedTime = `${hours < 10 ? "0" + hours : hours}:${minutes < 10 ? "0" + minutes : minutes
    }:${seconds < 10 ? "0" + seconds : seconds}`;

  let timeArray = formattedTime.split(":");
  let hour = parseInt(timeArray[0]);

  const [greeting, setgreeting] = useState("");
  useEffect(() => {
    let greeting = "";

    if (hour >= 6 && hour < 12) {
      greeting = "Good Morning ,";
    } else if ((hour >= 12 && hour < 16) || (hour >= 0 && hour < 4)) {
      greeting = "Good Afternoon ,";
    } else {
      greeting = "Good Evening ,";
    }
    setgreeting(greeting)
  }, [formattedTime]);

  const [counter, setcounter] = useState();

  let toastId = null; 

  const showOfferToastsucess = () => {
    if (!toastId || !toast.isActive(toastId)) {
      toastId = toast(
        <>
          <span
            style={{
              color: "#343131",
              display: "flex",
              justifyContent: "flex-end",
              alignItems: "flex-end",
              margin: "0",
              padding: "0",
              width: "100%",
            }}
            onClick={closeToast}
          >
            <RxCross2 />
          </span>
          <div className="main_first">
            <div className="first">
              <div className="center">
                <HiCheckBadge size={25} style={{ color: "green" }} />
              </div>
            </div>
            <div>
              <p>
                {greeting} {toTitleCase(userdetails.username)}
              </p>
            </div>

            <div>
              <p>Your Attendance Has Been Marked For Today</p>
            </div>

            <div className="last">
              <div className="last_first">
                <p>Date: {formattedDate}</p>
              </div>
              <div className="last_last">
                <p>Time: {formattedTime}</p>
              </div>
            </div>

            {/* ✅ Custom Close Button */}
            <div
              style={{
                display: "flex", // Enables Flexbox
                flexDirection: "column", // Stack elements vertically
                justifyContent: "flex-end", // Pushes items to the bottom
                textAlign: "right",
                // marginTop: "10px",
                height: "100%",
                padding: "10px",
              }}
            >
              <button
                onClick={closeToast}
                style={{
                  background: "red",
                  color: "#fff",
                  padding: "5px 10px",
                  marginTop: "100%",
                  border: "none",
                  cursor: "pointer",
                  marginTop: "auto",
                  alignSelf: "flex-end",
                  borderRadius: "6px",
                }}
              >
                Close
              </button>
            </div>
          </div>
        </>,
        {
          position: toast.POSITION.TOP_CENTER,
          autoClose: false,
          hideProgressBar: true,
          className: "toast-message",
          closeButton: false,
          onClose: () => {
            toastId = null;
          },
        }
      );
    }
  };

  const closeToast = () => {
    if (toastId) {
      toast.dismiss(toastId);
      toastId = null;
    }
  };

  const getdepartment = () => {
    axios
      .get(
        ServerAddress +
        `ems/Get_Clockin_time/?search=&data=all&p=1&records=10&first_login=true&userwise=${"user_name"}&Attendance_type=${"Attendance_type"}&from_date=${"from_date"}&to_date=${"to_date"}`,
        {
          headers: { Authorization: `Bearer ${accessToken}` },
        }
      )
      .then((response) => {
        let response_data = response?.data?.results;
        setis_first_login(response_data[0]?.is_first_login);
      })
      .catch((err) => {
        console.log(`Error Occur in Get , ${err}`);
      });
  };
  useEffect(() => {
    if (accessToken) {
      getdepartment();
    }
  }, []);

  useEffect(() => {
    if (
      is_first_login === true &&
      !localStorage.getItem("has_logged_in_before")
    ) {
      showOfferToastsucess();
      localStorage.setItem("has_logged_in_before", true);
    }
  }, [is_first_login]);

  // useEffect(() => {
  //   let dep_id = String(department.priority - 1).padStart(2, "0");
  //   if (dep_id === "00") {
  //     setdep_id("01");
  //   } else {
  //     setdep_id(dep_id);
  //   }
  // }, [department]);

  // To get Screen Size
  const { width } = useWindowDimensions();

  // for dashborad type
  const [dashboard_type, setdashboard_type] = useState("Home");
  const [dashboard_type_list, setdashboard_type_list] = useState([
    "Home",
    "Client",
    "Correction Request",
    "VMS",
    "TRIP",
    "BILLING",
    "OERATIONAL",
  ]);

  const [dashboard_time_frame_list, setdashboard_time_frame_list] = useState([
    "Monthly",
    "Half Monthly",
    "Weekly",
  ]);
  const [dashboard_time_frame, setdashboard_time_frame] = useState("");

  // Modal funcation
  const [show, setShow] = useState(false);

  const handleClose = () => setShow(false);
  const handleShow = () => {
    setShow(true);
    // setmessage_error(false)
  };

  const [birthday_list, setbirthday_list] = useState([""]);

  // for the Channel
  useEffect(() => {
    if (dashboard_type === "Channel") {
      navigate("/Channel");
    }
    if (dashboard_type === "Team Attendance") {
      navigate("/TeamAllAttendance");
    }
  }, [dashboard_type]);


  // <===================Sidebar Data==============================>



  return (
    <>
      <ToastContainer />
      {/* Birtday Modal */}
      <Modal show={show} onHide={handleClose} className="custom_modal">
        <Modal.Header closeButton>
          <Modal.Title
            style={{ fontFamily: "'Poppins', sans-serif", fontSize: "400" }}
          >
            {" "}
            Today's Birthdays
          </Modal.Title>
        </Modal.Header>
        <Modal.Body style={{ background: "#454545" }}>
          {birthday_list.length === 0 ? (
            <div
              className="birt_day"
              style={{ fontFamily: "Poppins sans-serif", fontSize: "400" }}
            >
              NO Birthdays Today
            </div>
          ) : (
            <>

              {birthday_list.map((item, idx) => (
                <BirthdayModal key={idx} {...item} />
              ))}
            </>
          )}
        </Modal.Body>
        <Modal.Footer>
          <Button
            variant="secondary"
            onClick={handleClose}
            style={{ fontFamily: "'Poppins', sans-serif", fontSize: "400" }}
          >
            Close
          </Button>
        </Modal.Footer>
      </Modal>

      <div
        style={{
          display: "flex",
          Width: width,
          // Width: "100%",
          flexDirection: width > 800 ? "row" : "column",
          background: "white",
          // background: "red",
        }}
      >
        {/* For Chart */}
        <div
          className="custom-scrollbars__content"
          style={{
            // background: "green",
            display: "flex",
            flexDirection: "column",
            padding: "10px",
            // flex: "0.75",
            overflowY: "scroll",
            postion:"fixed",
            maxHeight: "83vh",
            gap: "10px",
            maxWidth: width > 800 ? "80%" : "100%",
            minWidth: width > 800 ? "80%" : "100%",
            // border:'3px solid green',

            // justifyContent: "space-between",
          }}
        >
          {/* filter for admin */}

          {/* {(userdetails?.is_superuser || userdetails.emp_department.some(item => item.name === "HR")) && ( */}
          {/* <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              background: "blue",
              color: "white",
              padding: "4px",
              borderRadius: "12px",
              alignItems: "center",
              alignContent: "center",
            }}
          >
            <div
              style={{ cursor: "pointer" }}
              onClick={() => {
                navigate("/dashboard/DashboardTypes/SecondDashboard");
              }}
            >
              <FaExpandArrowsAlt />
            </div>

            <div
              style={{
                position: "relative",
                height: "100%",
                alignItems: "center",
                alignContent: "center",
              }}
            >
              <div
                className="responsive-child"
                onClick={() => {
                  navigate("/dashboard/DashboardTypes/BranchDailyDetails");
                }}
              >
                <FaCrosshairs color="white" />
              </div>
            </div>

            <div
              style={{
                background: "#DAD4B5",
                color: "black",
                borderRadius: "6px",
                cursor: "pointer",
              }}
            >
              <select
                style={{ borderRadius: "6px" }}
                onChange={(e) => {
                  setdashboard_type(e.target.value);
                }}
              >
                <option defaultValue={"Home"} value={"Home"}>
                  Home
                </option>
                <option value={"Correction Request"}>Correction Request</option>
                <option value={"Channel"}>Channel</option>
                <option value={"Team Attendance"}>Team Attendance</option>
              </select>
            </div>
          </div> */}
          {/* )} */}

          {dashboard_type === "Home" ? (
            <>
              <NewDasboard
                greeting={greeting}
                setcounter={setcounter}
                counter={counter}
              />
            </>
          ) : null}

          {dashboard_type === "Correction Request" ? (
            <>
              <div
                style={{
                  textAlign: "center",
                  fontSize: "32px",
                  fontFamily: "Georgia",
                  display: "flex",
                  postion: "relative",
                  padding: "inherit",
                }}
              >
                Correction Request
              </div>
              <CorrectionRequestDashboard />
            </>
          ) : null}
        </div>

        {/* For Timeline */}
        <div
          className="timeline-clss"
          style={{
            // flex: "0.25",
            Height: "83vh",
            maxWidth: width > 800 ? "20%" : "100%",
            minWidth: width > 800 ? "20%" : "100%",
          }}
        >
          <RightSidebar 
           show={show}
            setShow={setShow}
            holiday_data={counter}
             />
          {/* <DashboardTimelineSection
            show={show}
            setShow={setShow}
            holiday_data={counter}
          /> */}
        </div>
      </div>
    </>
  );
};

export default Dashboard;
